import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import _isEmpty from 'lodash/isEmpty';
import Range from '@app/model/_common/Range';

export type FilterIndicatorConfig<T> = {
	label: string;
	values: T[];
	keyPrefix: string;
	onRemove: (value: T) => void;
	formatValue: (value: T) => string;
};

const FilterIndicator = <T extends string | number | boolean | Range>({
	config 
}: { 
	config: FilterIndicatorConfig<T> 
}) => {
	if (_isEmpty(config.values)) return null;

	return (
		<>
			{config.values.map(value => (
				<div 
					key={`${config.keyPrefix}-${value}`}
					className="inline-flex items-center gap-x-0.5 rounded-md bg-white px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/30"
				>
					{config.label}: {config.formatValue(value)}
					<button 
						type="button" 
						className="group relative -mr-1 size-3.5 rounded-md hover:bg-gray-500/20" 
						onClick={() => config.onRemove(value)}
					>
						<XMarkIcon className="w-3.5 h-3.5 text-gray-600/50 group-hover:text-gray-600/75" />
					</button>
				</div>
			))}
		</>
	);
};

export default FilterIndicator;
